// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f82deaa7","453":"85d519c4","732":"d9f80534","977":"65bc8a37"}[chunkId] + ".chunk.js";
};